(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wheelDelta = (event, size) => {
    const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
    return delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? size : 1);
  };

  customElements.whenDefined('media-gallery').then(() => {
    const Gallery = customElements.get('media-gallery');
    if (Gallery.prototype.hckPairWheel) return;
    Gallery.prototype.hckPairWheel = true;
    const original = Gallery.prototype.initSlider;
    Gallery.prototype.initSlider = function () {
      original.call(this);
      if (!this.closest('[data-hck-stable-media]') || this.layout !== 'layout-6' || !this.navSlider) return;
      this.setAttribute('data-hck-pair-gallery', '');
      const nav = this.navSlider;
      const configure = (params) => {
        params.slidesPerView = 'auto';
        params.resistanceRatio = 0;
        params.freeModeMomentumBounce = false;
        params.slidesOffsetAfter = 0;
        if (params.breakpoints) Object.values(params.breakpoints).forEach(configure);
      };
      configure(nav.params);
      configure(nav.originalParams);
      nav.update();
      let target = nav.translate;
      let resizeFrame;
      const images = this.querySelector('.m-product-media--slider__images');
      const galleryResize = new ResizeObserver(() => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => {
          if (nav.destroyed) return;
          nav.update();
          target = nav.rtlTranslate ? -nav.translate : nav.translate;
        });
      });
      if (images) galleryResize.observe(images);
      nav.on('destroy', () => { galleryResize.disconnect(); cancelAnimationFrame(resizeFrame); });
      nav.on('touchStart', () => { target = nav.rtlTranslate ? -nav.translate : nav.translate; });
      const move = (delta) => {
        const current = nav.rtlTranslate ? -nav.translate : nav.translate;
        if (!nav.animating) target = current;
        const next = Math.max(nav.maxTranslate(), Math.min(nav.minTranslate(), target - delta));
        if (Math.abs(next - target) < .5) return false;
        target = next;
        nav.translateTo(next, reduced() ? 0 : 250, true, true);
        nav.updateActiveIndex();
        nav.updateSlidesClasses();
        return true;
      };
      nav.el.addEventListener('wheel', (event) => {
        if (event.ctrlKey || event.metaKey || nav.destroyed) return;
        if (move(wheelDelta(event, nav.size))) event.preventDefault();
      }, { passive: false });
      nav.el.addEventListener('keydown', (event) => {
        const delta = ['ArrowDown', 'ArrowRight', 'PageDown'].includes(event.key) ? 80 : ['ArrowUp', 'ArrowLeft', 'PageUp'].includes(event.key) ? -80 : 0;
        if (delta) { move(delta); event.preventDefault(); }
      });
      nav.slides.forEach((slide, index) => {
        slide.tabIndex = 0;
        slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', slide.querySelector('img')?.alt || `${index + 1}`);
        slide.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); slide.click(); }
        });
      });
    };
  });

  if (customElements.get('hck-suggest-pair')) return;
  customElements.define('hck-suggest-pair', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.hck-pair__track');
      const prev = this.querySelector('[data-pair-prev]');
      const next = this.querySelector('[data-pair-next]');
      const controls = this.querySelector('.hck-pair__controls');
      const motionButton = this.querySelector('[data-pair-motion]');
      const mobile = matchMedia('(max-width: 767px)');
      const rtl = getComputedStyle(track).direction === 'rtl';
      const position = () => Math.abs(track.scrollLeft);
      let target = position();
      let programmatic = false;
      const move = (delta) => {
        programmatic = true;
        target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target + delta));
        track.scrollTo({ left: rtl ? -target : target, behavior: reduced() ? 'instant' : 'smooth' });
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => { programmatic = false; target = position(); }, 350);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = track.querySelectorAll('.hck-pair__item').length < 3;
        prev.disabled = position() <= 1;
        next.disabled = position() >= max - 1;
      };
      track.addEventListener('scroll', () => {
        update();
        if (!programmatic) target = position();
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => { programmatic = false; target = position(); }, 100);
      }, { passive: true, signal });
      track.addEventListener('pointerdown', () => { programmatic = false; target = position(); }, { signal });
      track.addEventListener('wheel', (event) => {
        if (event.ctrlKey || event.metaKey) return;
        const delta = wheelDelta(event, track.clientWidth);
        const max = track.scrollWidth - track.clientWidth;
        if (max < 1 || delta > 0 && target >= max - 1 || delta < 0 && target <= 1) return;
        event.preventDefault();
        move(delta);
      }, { passive: false, signal });
      prev.addEventListener('click', () => move(-track.clientWidth), { signal });
      next.addEventListener('click', () => move(track.clientWidth), { signal });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        const step = track.clientWidth / 3;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -step : step));
        }
      }, { signal });
      this.animations = new Map();
      this.titlePaused = false;
      this.titleVisible = new Set();
      let windowVisible = false;
      const titles = [...this.querySelectorAll('.hck-pair__item')].map(item => ({ item, title: item.querySelector('.hck-pair__title'), span: item.querySelector('.hck-pair__title span') }));
      const updateTitlePlayback = () => {
        if (!mobile.matches) return;
        this.animations.forEach((animation, item) => {
          if (this.titlePaused || document.hidden || !windowVisible || !this.titleVisible.has(item)) animation.pause();
          else animation.play();
        });
      };
      const syncTitles = () => {
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        const metrics = titles.map(entry => ({ ...entry, distance: entry.span.scrollWidth - entry.title.clientWidth }));
        motionButton.hidden = !mobile.matches || reduced() || !metrics.some(entry => entry.distance > 0);
        if (!mobile.matches || reduced()) return;
        metrics.forEach(({ item, span, distance }) => {
          if (distance <= 0) return;
          const animation = span.animate([
            { transform: 'translateX(0)', offset: 0 },
            { transform: 'translateX(0)', offset: .15 },
            { transform: `translateX(${rtl ? distance : -distance}px)`, offset: .85 },
            { transform: `translateX(${rtl ? distance : -distance}px)`, offset: 1 }
          ], { duration: Math.max(2200, distance * 35), easing: 'linear', direction: 'alternate', iterations: Infinity });
          animation.pause();
          this.animations.set(item, animation);
        });
        updateTitlePlayback();
      };
      this.titleObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) this.titleVisible.add(entry.target); else this.titleVisible.delete(entry.target); });
        updateTitlePlayback();
      }, { root: track, threshold: .1 });
      titles.forEach(({ item }) => this.titleObserver.observe(item));
      this.windowObserver = new IntersectionObserver(entries => { windowVisible = entries[0].isIntersecting; updateTitlePlayback(); });
      this.windowObserver.observe(this);
      document.addEventListener('visibilitychange', updateTitlePlayback, { signal });
      motionButton.addEventListener('click', () => {
        this.titlePaused = !this.titlePaused;
        motionButton.setAttribute('aria-pressed', String(this.titlePaused));
        motionButton.setAttribute('aria-label', this.titlePaused ? motionButton.dataset.playLabel : motionButton.dataset.pauseLabel);
        motionButton.querySelector('path').setAttribute('d', this.titlePaused ? 'm8 5 11 7-11 7Z' : 'M9 5v14M15 5v14');
        updateTitlePlayback();
      }, { signal });
      titles.forEach(({ item, title, span }) => {
        const reset = () => { this.animations.get(item)?.cancel(); this.animations.delete(item); };
        const reveal = () => {
          if (mobile.matches) return;
          reset();
          const distance = span.scrollWidth - title.clientWidth;
          if (distance <= 0 || reduced()) return;
          this.animations.set(item, span.animate([
            { transform: 'translateX(0)', offset: 0 },
            { transform: 'translateX(0)', offset: .12 },
            { transform: `translateX(${rtl ? distance : -distance}px)`, offset: .85 },
            { transform: `translateX(${rtl ? distance : -distance}px)`, offset: 1 }
          ], { duration: Math.min(5000, Math.max(1500, distance * 28)), easing: 'linear', fill: 'forwards' }));
        };
        item.addEventListener('pointerenter', reveal, { signal });
        item.addEventListener('pointerleave', () => { if (!mobile.matches) reset(); }, { signal });
        item.addEventListener('focusin', reveal, { signal });
        item.addEventListener('focusout', (event) => { if (!mobile.matches && !item.contains(event.relatedTarget)) reset(); }, { signal });
      });
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      motion.addEventListener('change', syncTitles, { signal });
      mobile.addEventListener('change', syncTitles, { signal });
      this.resize = new ResizeObserver(() => { target = position(); update(); syncTitles(); });
      this.resize.observe(track);
      document.fonts.ready.then(() => { if (!signal.aborted) syncTitles(); });
      update();
      syncTitles();
      this.addEventListener('submit', async (event) => {
        const form = event.target.closest('.hck-pair__form');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled) return;
        const status = this.querySelector('.hck-pair__status');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        const drawer = document.querySelector('m-cart-drawer');
        const data = new FormData(form);
        if (drawer?.getSectionsToRender) {
          data.append('sections', [...new Set(drawer.getSectionsToRender().map(section => section.id))].join(','));
          data.append('sections_url', location.pathname);
        }
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' }, signal });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
          status.textContent = status.dataset.success;
          button.querySelector('svg').innerHTML = '<path d="m5 12 4 4L19 6"/>';
          const theme = window.MinimogTheme;
          window.MinimogEvents?.emit(theme?.pubSubEvents?.cartUpdate || 'cart:update', result);
          if (drawer && window.MinimogSettings?.enable_cart_drawer && result.sections) {
            drawer.setActiveElement?.(button);
            try { drawer.renderContents(result); } catch { drawer.onCartDrawerUpdate?.(); }
          }
          this.successTimer = setTimeout(() => { button.querySelector('svg').innerHTML = '<path d="M12 5v14M5 12h14"/>'; }, 1800);
        } catch (error) {
          status.textContent = error.message === 'Failed to fetch' ? status.dataset.error : error.message;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      this.titleObserver?.disconnect();
      this.windowObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      clearTimeout(this.successTimer);
      clearTimeout(this.scrollTimer);
    }
  });
})();
